exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active,\n.fade-leave-active {\n  transition: opacity 0.5s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n.btn-custom-green {\n  background-color: rgb(25, 159, 46) !important;\n  margin-right: 7px;\n}\n.btn-custom-green:hover {\n  background-color: rgb(20, 140, 38) !important;\n}\n", ""]);

// exports
